module.exports = __webpack_public_path__ + "ac3bb098300c903e96009df2e165535f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/chamomile.jpg
 ** module id = 196
 ** module chunks = 0
 **/